import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { Buffer } from 'buffer';

import App from './App.tsx';
import AppCrashScreen from './components/common/AppCrashScreen.tsx';
import { AGENT_DASHBOARD_TOKEN_STORAGE_KEY, getAgentDashboardToken } from './apps/apis/claudeCodeDashboard/instance.ts';
import { devTokenToInstall, setDevTokenHint } from './apps/apis/claudeCodeDashboard/devToken.ts';
import QueryProvider from './providers/QueryProvider.tsx';
import { AuthProvider } from './providers/AuthProvider.tsx';
import { StaffAuthProvider } from '@/providers/StaffAuthProvider.tsx';
import { recordPrintSetup } from '@/pages/fulfillment/components/printSetup';
import './globals.css';
import 'bootstrap/dist/css/bootstrap.min.css';

window.Buffer = Buffer;

// The label printer setup file reopens the admin with ?printSetup=done; keep that mark before a login redirect drops it.
recordPrintSetup();

// Dev server only — Vite strips this block from production builds along with the token and the hint text.
if (import.meta.env.DEV) {
  const devToken = devTokenToInstall({
    envToken: import.meta.env.VITE_DEV_DASHBOARD_JWT,
    existingToken: getAgentDashboardToken(),
  });
  if (devToken) {
    localStorage.setItem(AGENT_DASHBOARD_TOKEN_STORAGE_KEY, devToken);
  }
  setDevTokenHint('Run `npm run dev:token` and refresh to mint a local one.');
}

// Environment logging handled by Vite in development
// This is disabled during tests

// One catch-all data route around the app: Router.tsx keeps its <Routes>, and useBlocker can now stop any route change
// (SSD-7815). Created here, after recordPrintSetup above has tidied the address, so the router reads the final URL.
const router = createBrowserRouter([
  {
    path: '*',
    errorElement: <AppCrashScreen />,
    element: (
      <AuthProvider>
        <QueryProvider>
          <App />
        </QueryProvider>
      </AuthProvider>
    ),
  },
]);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <GoogleOAuthProvider clientId="639007308170-lcrsao9lgj3km159oo6uj2sjhs8tbrb8.apps.googleusercontent.com">
      <StaffAuthProvider>
        <RouterProvider router={router} />
      </StaffAuthProvider>
    </GoogleOAuthProvider>
  </StrictMode>,
);
